/*global Modernizr, Dropzone, tippy, Splide */
/*jslint browser:true */

(function() {
  'use strict';

  tippy('a[target=_blank]', {
    content: 'Opens in a new window.',
    arrow: true,
    theme: 'monkeeboy',
  });

  const body = document.querySelector('body');

  const mobile_trigger = document.querySelector('.mobile-trigger a');
  const svg = document.getElementById('mobile-menu-icon');
  mobile_trigger.addEventListener('click', function(e) {
    e.preventDefault();

    if(body.parentNode.classList.contains('mobile-nav-open')) {
      body.parentNode.classList.remove('mobile-nav-open');
      body.parentNode.classList.add('mobile-nav-closed');
    } else {
      body.parentNode.classList.remove('mobile-nav-closed');
      body.parentNode.classList.add('mobile-nav-open');
    }
  });

  const content_container = document.querySelector('.content');
  content_container.addEventListener('click', function(e) {
    if(body.parentNode.classList.contains('mobile-nav-open')) {
      e.preventDefault();

      body.parentNode.classList.remove('mobile-nav-open');
      body.parentNode.classList.add('mobile-nav-closed');

      svg.classList.remove('mobile-menu-animation-step-three');
    }
  });

  const nav_dropdowns = document.querySelectorAll('nav .has-dropdown > a');
  Array.prototype.forEach.call(nav_dropdowns, function(dropdown) {
    dropdown.addEventListener('click', function(e) {
      e.preventDefault();

      this.parentNode.classList.toggle('open');
    });
  });

  const dragdrops = document.querySelectorAll('.file-dragdrop');
  if(dragdrops) {
    Array.prototype.forEach.call(dragdrops, function(dragdrop) {
      var dropzoneTemplate = document.querySelector('.dropzone_preview_template').cloneNode(true);
      dropzoneTemplate.querySelector('.input-file-name').setAttribute('name', dragdrop.getAttribute('data-field') + '[name][]');
      dropzoneTemplate.querySelector('.input-file-tmp').setAttribute('name', dragdrop.getAttribute('data-field') + '[tmp_name][]');

      var upload_url = dragdrop.parentNode.parentNode.parentNode.getAttribute('action');
      upload_url = upload_url.replace('/submit/', '/file_upload/');

      var csrfToken, cookie_str;
      var cookies = document.cookie.split(';');
      for (var cookieIter = 0; cookieIter < cookies.length; cookieIter++) {
        cookie_str = cookies[cookieIter].split('=');
        cookie_str[0] = cookie_str[0].trim();
        if (cookie_str[0] === 'csrfToken') {
          csrfToken = cookie_str[1];
          break;
        }
      }

      var dropzone = new Dropzone(dragdrop, {
        url: upload_url,
        maxFilesize: 10, // MB
        acceptedFiles: '.pdf,.doc,.docx,.txt',
        previewsContainer: dragdrop.nextElementSibling,
        previewTemplate: dropzoneTemplate.innerHTML,
        dictFileTooBig: "File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        headers: {
          'X-CSRF-Token': csrfToken
        },
        success: function(file, data) {
          if(data.response === 'success') {
            file.previewElement.classList.add("dz-success");
            file.previewElement.querySelector('.input-file-name').setAttribute('value', data.files[0].name);
            file.previewElement.querySelector('.input-file-tmp').setAttribute('value', data.files[0].tmp_name);
          } else {
            file.previewElement.classList.add('dz-error');
            file.previewElement.querySelector('.input-file-name').remove();
            file.previewElement.querySelector('.input-file-tmp').remove();
            file.previewElement.querySelector('.dz-error-message span').textContent = 'Error uploading file';
          }
        },
        error: function(file, message) {
          if(typeof message !== 'string' && message.message) {
            message = message.message;
          }

          file.previewElement.classList.add("dz-error");
          file.previewElement.querySelector('.input-file-name').remove();
          file.previewElement.querySelector('.input-file-tmp').remove();
          file.previewElement.querySelector('.dz-error-message span').textContent = message;
        }
      });
    });
  }

  const form_buttons = document.querySelectorAll('.js-form-submit');
  if(form_buttons) {
    Array.prototype.forEach.call(form_buttons, function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();

        this.parentNode.parentNode.parentNode.submit();
      });
    });
  }

  const view_all_link = document.querySelector('.js-triggerViewAllAnimation');
  if(view_all_link) {
    view_all_link.addEventListener('mouseenter', function( event ) {
      document.getElementById('animate-in').beginElement();
    }, false);

    view_all_link.addEventListener('mouseleave', function( event ) {
      document.getElementById('animate-out').beginElement();
    }, false);
  }

  // shoot bananas from the footer
  const bananas = document.querySelector('.bananas');
  function shoot_bananas() {
    var a = 0.8, // vertical accelleration
        num_bananas = Math.ceil(Math.random() * 5),
        pos = [0, -60];

    // create some bananas and shoot them
    for (var i = 0; i < num_bananas; i++) {
      var banana = document.createElement('div'),
          vx = (0.5 - Math.random()) * 10, // horizontal velocity, can be positive or negative
          vy = -Math.random() * 20; // initial vertical velocity

      banana.classList.add('shooting-banana');
      bananas.appendChild(banana);
      update_banana_pos(banana, pos, vx, vy, a);
    }
  }

  bananas.addEventListener('mouseenter', shoot_bananas, false);

  function update_banana_pos(banana, p0, vx, vy, a) {
    // we're under the assumption that 1 time unit has passed each iteration
    var posX = p0[0] + vx,
        posY = p0[1] + vy,
        transform = 'matrix(1, 0, 0, 1, '+ posX + ', '+ posY +')';

    // update velocity
    vy += a;

    // set the transform
    banana.style.transform = transform;

    // if posX is greater than 20px below, keep going
    if ( posY < 60) {
      requestAnimationFrame(function() {
        update_banana_pos(banana, [posX, posY], vx, vy, a);
      });
    } else {
      banana.remove();
    }
  }

  const alert_close = document.querySelector('.alert .close');
  if(alert_close) {
    alert_close.addEventListener('click', (e) => {
      e.preventDefault();
      alert_close.parentNode.classList.add('hidden');
    });
  }

  var slideshows = document.querySelectorAll('.slideshow');
  if(slideshows) {
    slideshows.forEach((slideshow) => {
      var slideshow_slider = new Splide( slideshow, {
        type: 'loop',
        perPage: 1,
        arrows: true,
        pagination: false,
        autoHeight: true,
        classes: {
          arrow : 'button splide__arrow',
        }
      } );

      slideshow_slider.on('mounted', function () {
        var slide_length = slideshow_slider.length,
            slide_arrows_container = slideshow_slider.root.querySelector('.splide__arrows'),
            arrow_prev = slide_arrows_container.querySelector('.splide__arrow--prev'),
            arrow_next = slide_arrows_container.querySelector('.splide__arrow--next');

        arrow_prev.innerHTML = '<span><svg viewBox="0 0 32 32" class="icon"><use xlink:href="#arrow"></use></svg></span>';
        arrow_next.innerHTML = '<span><svg viewBox="0 0 32 32" class="icon"><use xlink:href="#arrow"></use></svg></span>';

        var paging = document.createElement('div');
        paging.classList.add('splide-paging');
        paging.innerHTML = '<span class="current-page">1</span>/<span class="total-pages">' + slide_length + '</span>';

        arrow_prev.insertAdjacentElement('afterend', paging);
      });

      slideshow_slider.on('move', function(newIndex) {
        var slide_arrows_container = slideshow_slider.root.querySelector('.splide__arrows'),
            current_page = slide_arrows_container.querySelector('.splide-paging .current-page');

        current_page.innerText = newIndex + 1;
      });

      slideshow_slider.mount();
    });
  }

  var jungle_news_container = document.querySelector('.jungle-news-slider');
  if(jungle_news_container) {
    var jungle_news_slider = new Splide( jungle_news_container, {
      type: 'slide',
      perPage: 3,
      perMove: 3,
      arrows: true,
      pagination: false,
      autoHeight: true,
      padding: 140,
      gap: 30,
      breakpoints: {
        1120: {
          perPage: 2,
          perMove: 2,
          padding: 140
        },
        750: {
          perPage: 1,
          perMove: 1,
          padding: 15
        }
      },
      classes: {
        arrow : 'button splide__arrow',
      }
    } );

    jungle_news_slider.on('mounted', function () {
      var slide_arrows_container = jungle_news_slider.root.querySelector('.splide__arrows'),
          arrow_prev = slide_arrows_container.querySelector('.splide__arrow--prev'),
          arrow_next = slide_arrows_container.querySelector('.splide__arrow--next');

      arrow_prev.innerHTML = '<span><svg viewBox="0 0 32 32" class="icon"><use xlink:href="#arrow"></use></svg></span>';
      arrow_next.innerHTML = '<span><svg viewBox="0 0 32 32" class="icon"><use xlink:href="#arrow"></use></svg></span>';
    });

    jungle_news_slider.mount();
  }
}());
